import { DatasetItem } from '../../types/types';

export const isUnformattedFloatItem = (item: DatasetItem): boolean =>
  item.type === 'float' && !item.format && !item.formatItem;
